import { default as CookieDisclaimerModule } from "./cookie-disclaimer-module";
export { CookieDisclaimerModule };
